(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[71143],{

/***/ 71143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_PersonIntro; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/PersonIntro/utils/usePersonProps.js



/* harmony default export */ function usePersonProps(props) {
    var _socialLinks = props.socialLinks, socialLinks = _socialLinks === void 0 ? [] : _socialLinks, rest = (0,_object_without_properties/* default */.Z)(props, [
        "socialLinks"
    ]);
    var socialMedia = socialLinks.map(function(link) {
        return (0,helper/* getDocumentFields */.OA)(link, [
            "svgType",
            "url"
        ]);
    });
    return (0,_object_spread/* default */.Z)({
        socialMedia: socialMedia
    }, rest);
};

// EXTERNAL MODULE: ./UI/sections/PersonIntro/styles.module.scss
var styles_module = __webpack_require__(29045);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/PersonIntro/index.jsx







var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Media = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(34190)]).then(__webpack_require__.bind(__webpack_require__, 34190));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34190)
            ];
        }
    }
});
var Svg = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var PersonIntro = function(_param) {
    var introSection = _param.introSection, props = (0,_object_without_properties/* default */.Z)(_param, [
        "introSection"
    ]);
    var ref = usePersonProps(props), avatar = ref.avatar, fullName = ref.fullName, position = ref.position, quote = ref.quote, bio = ref.bio, socialMedia = ref.socialMedia;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ref: introSection,
        className: (styles_module_default()).introSection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).contentWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, {
                    type: "isReveal",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Media, {
                        asset: avatar,
                        className: (styles_module_default()).avatar
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).infoContainer,
                    children: [
                        fullName && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (styles_module_default()).fullName,
                            children: fullName
                        }),
                        position && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (styles_module_default()).position,
                            children: position
                        }),
                        quote && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (styles_module_default()).quote,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                                    type: "bookMarkQuote",
                                    className: (styles_module_default()).bookMarkQuoteIcon
                                }),
                                quote
                            ]
                        }),
                        bio && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (styles_module_default()).biography,
                            children: bio
                        }),
                        !!socialMedia.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).socialMediaList,
                            children: socialMedia.map(function(param) {
                                var svgType = param.svgType, url = param.url;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                    path: url,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                                        type: svgType,
                                        className: (styles_module_default()).socialMediaIcon
                                    })
                                }, svgType);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var sections_PersonIntro = (PersonIntro);


/***/ }),

/***/ 29045:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"introSection":"styles_introSection__GLrwO","contentWrapper":"styles_contentWrapper__8Pz98","avatar":"styles_avatar__NRHtg","fullName":"styles_fullName__MW74t","position":"styles_position__i8vA6","quote":"styles_quote__pZXf2","bookMarkQuoteIcon":"styles_bookMarkQuoteIcon__RxOR0","biography":"styles_biography__tT5gw","socialMediaList":"styles_socialMediaList__Tno2b","socialMediaIcon":"styles_socialMediaIcon__AgF3N"};

/***/ })

}]);